<template>
  <v-app class="survey-container">
    <NavBarHome></NavBarHome>
      <br/>
      <v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
      <v-avatar slot="icon" color="deep-orange accent-4" size="40">
        <v-icon color="white">
          people_alt
        </v-icon>
      </v-avatar>
      You are viewing the survey of <strong>{{officeDescription}}</strong>.
      <template v-slot:actions>
        <v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
      </template>
    	</v-banner>
  	<br/>
    <v-layout class="page-body pt-6 admin-page bg-light-blue">
      <v-layout row>
        <!-- *** help pane (left side) ***  -->
        <v-flex column md2 class="page-help">
					<div>
            <hr />
            <h4>Related tasks</h4>
            <p>Aggregate suboffice(s) data</p>
            <v-btn normal :disabled="isSurveyLocked" class="form-button" @click="onDontForgetToRemove">Aggregate Data</v-btn>
          </div>
					<div>
            <hr />
            <p>Monitor suboffice(s) progress</p>
            <v-btn normal :disabled="isSurveyLocked" class="form-button" @click="navigateToProgressMonitor">MONITOR PROGRESS</v-btn>
						<hr />
          </div>
          <div>
            <h4>On this page:</h4>
            <ul class="bulleted-list">
              <li>Open a suboffice survey</li>
              <li>Edit suboffice contact information</li>
              <li>Send system message with access info to suboffice staff</li>
              <li>Lock the suboffice surveys to prevent data changes; or Unlock to allow data changes</li>
              <li>Add suboffices</li>
            </ul>
          </div>
					<div>
						<hr />
            <v-btn normal class="form-button" @click="onCancel">
              <v-icon medium>home</v-icon>&nbsp; Home
            </v-btn>
          </div>
        </v-flex>

        <!-- *** main body (right side) ***  -->
        <v-flex column md10 pt-6 pb-3>
          <h1>Manage Reporting Units</h1>
          <h3>To e-mail or lock/unlock offices, first select the office by clicking in the box to the left of the User ID.<br/> That activates the E-MAIL SELECTED OFFICE(S) and LOCK/UNLOCK SELECTED OFFICE(S) buttons below the table.</h3>
          <h2>Participating Suboffice(s)</h2>
          <v-flex xs12 class="horiz-margin-20">

            <v-data-table
              v-model="officeParticipation"
              :headers="officeParticipationHeaders"
              :items="participatingOffices"
              :single-select="false"
              item-key="userName"
              show-select
              class="elevation-1">

            <!--template #item.email="{ value }">
              <a :href="`mailto:${value}`">
                {{ value }}
              </a>
            </template-->
            <template #item.userName={value} >
              <a href="#" @click="switchuser(value,participatingOffices); return false;">{{value}}</a>
            </template>
            <template #item.officeName={value} >
              <a href="#" @click="onAddNewOffice(value,false);">{{value}}</a>
            </template>
            </v-data-table>
          </v-flex>

          <v-layout data-app wrap row>
            <v-flex xs12 class="horiz-margin-20">
              <div class="buttons">&nbsp;<span style="color:blue;">{{participatingOffMessages}}</span>
              <span>&nbsp;E-mail URL, User ID, and Password to the selected office(s).&nbsp;</span>
                <v-btn
                  normal
                  class="form-button"
                  @click="onEmailSelectedOffices"
                  :disabled="!officeParticipation || officeParticipation.length === 0"
                >
                <v-icon medium>e-mail</v-icon>&nbsp;E-mail Selected Office(s)</v-btn>&nbsp;
                <v-btn normal
                  class="form-button"
                  @click="onLockSelectedOffices"
                  :disabled="!officeParticipation || officeParticipation.length === 0"
                 >
                  <v-icon medium>lock</v-icon>&nbsp;Lock\Unlock Selected Office(s)
                </v-btn>
              </div>
              <!--Model popup window to add Office-->
              <div>
                <b-modal size="xl"  ref="my-modal" hide-footer v-model="addorupdateflag" :title="headingtitle" :no-close-on-backdrop="true" :no-close-on-esc="true">
                  <div>
                    <v-form ref="form" lazy-validation>
                      <b-container fluid>
                        <b-row class="mb-1">
                          <b-col cols="3">Department Type <span style="color:red">*</span></b-col>
                          <b-col>
                            <select v-model="addOffice.selectDeptType" class="form-control" @change="onChangeDepartmentType($event)" required :rules="deptTypeRule" :disabled="disableFlag">
                              <option value="" selected>Select</option>
                              <option v-for="deptType in departmentTypes" :value="deptType.id" :key="deptType.id">{{ deptType.name }}</option>
                            </select>
                          </b-col>
                          <b-col cols="3">Department <span style="color:red">*</span></b-col>
                          <b-col>
                            <select v-model="addOffice.selectDeptment" class="form-control" required :rules="deptRule" :disabled="disableFlag">
                              <option value="" selected>Select</option>
                              <option v-for="deptment in departments" :value="deptment.departmentId" :key="deptment.departmentId">{{ deptment.departmentName }}</option>
                            </select>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Office Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.officeName" label="Office Name" required :rules="officeNameRule"></v-text-field>
                          </b-col>
                          <b-col cols="3">Office Abbreviation <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.officeAbbreviation" label="Office Abbreviation" required :rules="officeAbbreviationRule"></v-text-field>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">Description</b-col>
                          <b-col>
                            <textarea v-model="addOffice.description" rows="5" cols="60" placeholder="Enter text" class="form-control" name="description" :min-height="200"
														:max-height="400"></textarea>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">First Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.firstName" label="First Name" required :rules="firstNameRule"></v-text-field>
                          </b-col>
                          <b-col cols="3">Last Name <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.lastName" label="Last Name" required :rules="lastNameRule"></v-text-field>
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">E-mail <span style="color:red">*</span></b-col>
                          <b-col>
                            <v-text-field v-model="addOffice.emailId" label="E-mail" required :rules="emailRule"></v-text-field>
                          </b-col>
                          <b-col cols="3">Title</b-col>
                          <b-col>
                            <input v-model="addOffice.title" type="text" class="form-control" id="title" name ="title"/>
                          </b-col>
                        </b-row>
                         <b-row class="mb-1">
                          <b-col cols="3">Supervisor First Name</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisorfirstName" type="text" class="form-control" id="supervisorfirstName" name="supervisorfirstName"/>
                          </b-col>
                          <b-col cols="3">Supervisor Last Name</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisorlastName" type="text" class="form-control" id="supervisorlastName" name ="supervisorlastName" />
                          </b-col>
                        </b-row>
                        <b-row class="mb-1">
                          <b-col cols="3">Supervisor E-mail</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisoremailId" type="text" class="form-control" id="supervisoremailId" name="supervisoremailId"/>
                          </b-col>
                          <b-col cols="3">Supervisor Title</b-col>
                          <b-col>
                            <input v-model="addOffice.supervisorTitle" type="text" class="form-control" id="supervisorTitle" name ="supervisorTitle"/>
                            <input v-model="addOffice.userId" type="hidden" id="userId"/>
                          </b-col>
                        </b-row>
												<b-row class="mb-1">
                          <b-col cols="2"><b-button class="form-button" :loading="isLoading" v-model="headingtitle" block @click="onSaveOffice(headingtitle)">Save</b-button></b-col>
                          <b-col cols="2"><b-button class="form-button" @click="hideModal">Cancel</b-button></b-col>
                        </b-row>
                      </b-container>
											<div>
												&nbsp;<span style="color:blue;">{{message}}</span>
											</div>
                    </v-form>
                   </div>
                </b-modal>
              </div>
            </v-flex>
          </v-layout>

          <h2>Add New Office(s)</h2>
          <p>Select the Add New Office button. Fill in the form that opens, save it, and close the form. Back on the Manage Reporting Units screen, <br/> click in the box to the left of the User ID. That activates the ADD SELECTED OFFICE(S) button. Select that button to add the office to Participating Suboffices table.
          </p>
          <v-flex xs12 class="horiz-margin-20">
            <v-data-table
              v-model="officeSelection"
              :headers="officeSelectionHeaders"
              :items="offices"
              :single-select="false"
              item-key="userName"
              show-select
              class="elevation-1">
            <template #item.officeName={value} >
              <a href="#" @click="onAddNewOffice(value,false);">{{value}}</a>
            </template>
            </v-data-table>
          </v-flex>

          <v-layout data-app wrap row>
            <v-flex xs12 class="horiz-margin-20">
              <div class="buttons">&nbsp;<span style="color:blue;">{{officeMessage}}</span>
                <v-btn normal  :loading="isLoading" class="form-button"  @click="onAddSelectedOffices" :disabled="disablemakeOfficeinUseFlag || !officeSelection || officeSelection.length === 0">Add Selected Office(s)</v-btn>&nbsp;
                <v-btn normal class="form-button" :disabled="isSurveyLocked" @click="onAddNewOffice(officename,true)">Add New Office</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
   <Footer></Footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { authTokenService } from '@/services/authTokenService.js';
import { CONSTANTS } from '@/common/constants.js';
import router from '@/router';
import { officeManagementService } from '@/services/officeManagementService.js';
import { authService } from "@/services/authService.js";
import { surveyService } from "@/services/surveyService.js";

export default {
	name: 'ReportingUnits',
	data: () => ({
        singleSelect: true,
        officeParticipation: [],
        officeParticipationHeaders: [
          { text: 'User ID (Click ID to open office’s survey)', value: 'userName', class: 'cellclname' },
					{ text: 'Password', value: 'showPassword' },
          { text: 'Office Name (Click name to edit office contact information)', value: 'officeName', class: 'cellLink' },
          { text: 'Office Abbreviation', value: 'officeAbbreviation' },
          { text: 'Primary Contact', value: 'nameFirst' },
          { text: 'Primary E-mail Address', value: 'email' },
          { text: 'Survey Locked?', value: 'isLocked' },
					{ text: 'Survey Status', value: 'surveyStatus' }
        ],
        participatingOffices: [],
        officeSelection: [],
        officeSelectionHeaders: [
          { text: 'User ID', value: 'userName', class: 'cellclname' },
          { text: 'Office Name (Click name to edit office contact information)', value: 'officeName' },
          { text: 'Office Abbreviation', value: 'officeAbbreviation' },
          { text: 'Primary Contact', value: 'nameFirst' },
          { text: 'Primary E-mail Address', value: 'email' },
        ],
        offices: [],
        participatingOfficesList:[],
        section: null,
		    columns: null,
		    columnHeader: null,
        departmentTypes:[
          { name: "Department", id: 1 },
          { name: "Independent Agency", id: 2 }
        ],
        selectedDepartmentType: null,
        departments:[],
        //Validtion rules
        emailRule: [
            v => !!v || "E-mail is required",
            v => /.+@.+/.test(v) || "E-mail must be valid"
        ],
        officeNameRule:[v => !!v || 'Office Name is required'],
        officeAbbreviationRule:[v => !!v || 'Office Abbreviation is required',
        v => (v && v.length <= 21) || 'Office Abbreviation must be less than 20 characters'],
        firstNameRule:[v => !!v || 'First Name is required'],
        lastNameRule:[v => !!v || 'Last Name is required'],
        deptTypeRule: [v => !!v || 'Department Type is required'],
        deptRule: [v => !!v || 'Department is required'],
        message: '',
        //Variables
        addOffice:{
          agency:null,
          officeName:null,
          officeAbbreviation:null,
          description:null,
          firstName:null,
          lastName:null,
          emailId:null,
          title:null,
          supervisorfirstName:null,
          supervisorlastName:null,
          supervisoremailId:null,
          supervisorTitle:null,
          selectDeptType:null,
          selectDeptment:null,
          departmentId: null,
          userId: null,
        },
        headingtitle:null,
        addorupdateflag:null,
        officeMessage:null,
        participatingOffMessages: null,
        disableFlag:null,
        disablemakeOfficeinUseFlag:null,
        surveyRootId:null,
        isLoading: false,
        isSurveyLocked:null,
				impersonation: false,
	}),
	methods: {
				exit () {
					router.push({ name: 'admin.stats' });
				},
        onDontForgetToRemove () {
            router.push({ name: 'officeaggregation' });
        },
				navigateToProgressMonitor () {
            router.push({ name: 'progressmonitor' });
        },
        onEmailSelectedOffices: function() {
          debugger;
          const me = this;
          me.$data.isLoading = true;
          me.participatingOffMessages="Sending please wait.."
          const currentVolume = authTokenService.getCurrentVolume();
          for(var i=0; i<me.officeParticipation.length; i++)
          {
            debugger;
               authService.emailSelectedOffices(me.officeParticipation[i].email, me.officeParticipation[i].userName, currentVolume).then(function(response) {
                  me.$data.emailed = true;
                  me.$data.error = false;
                  me.participatingOffMessages = "E-mail sent to the selected offices";
                })
                .catch(function(response) {
                  console.log("OnEmail Selected Offices handle error in component");
                  me.$data.isLoading = false;
                  me.$data.error = true;
                  me.$data.emailed = false;
                  me.participatingOffMessages = response.data;
                });
          }
          me.$data.isLoading = false;
        },
        onLockSelectedOffices () {
          const me = this;
          me.$data.isLoading = true;
          me.participatingOffMessages="Processing please wait..";
          for(var i=0; i<me.officeParticipation.length; i++)
          {
              var block=null;
              if(me.officeParticipation[i].isLocked=='No')
              {
                block=true;
              }
              else if(me.officeParticipation[i].isLocked=='Yes')
              {
                  block=false;
              }
              surveyService.setSurveyLockStatus(me.officeParticipation[i].surveyId,block).then(function (resp) {
                  me.$data.isLoading = false;
                  me.participatingOffMessages="Selected offices Lock or Unlock completed";
                })
                .catch(function (err) {
                  me.$data.isLoading = false;
                      console.log(err);
                      console.log("Error attempting to lock survey");
                      me.participatingOffMessages= err;
                      throw err;
                });
          }
          me.$data.isLoading = false;
          const activeSurveyId = authTokenService.getActiveSurveyId();

          me.participatingOffices=[];
          officeManagementService.getSubOffices(activeSurveyId).then(function (response){
            if (response && response.data)
            {
              for(var i=0;i<response.data.length;i++)
              {
                 me.participatingOffices.push(response.data[i]);
              }
            }
          });
        },
        onChangeDepartmentType (event) {
          const me=this;
          me.selectedDepartmentType = event.target.options[event.target.options.selectedIndex].text;
          var departType=0;
          me.departments=[];
          if(me.selectedDepartmentType=="Department")
            {departType=1}
          else
            {departType=2};
          officeManagementService.getAllDepartments(departType).then(function (response){
            if (response && response.data) {
              for(var i=0;i<response.data.length;i++)
              {
                me.departments.push(response.data[i]);
              }
            }
          });
        },
        onAddNewOffice (officename, flag) {
          const me = this;
          me.addorupdateflag = flag;
          if (officename !=null && !flag) {
              me.headingtitle = "Update Office and Contact Information";
							me.message = '';
              surveyService.getOfficeInfo(officename).then(function (response) {
              if (response && response.data) {
                  me.disableFlag = true;
                  me.addOffice.agency = response.data.agency;
                  me.addOffice.officeName = response.data.officeName;
                  me.addOffice.officeAbbreviation = response.data.officeAbbreviation;
                  me.addOffice.description = response.data.description;
                  me.addOffice.firstName = response.data.nameFirst;
                  me.addOffice.lastName = response.data.nameLast;
                  me.addOffice.emailId = response.data.email;
                  me.addOffice.title = response.data.title;
                  me.addOffice.supervisorfirstName = response.data.supNameFirst;
                  me.addOffice.supervisorlastName = response.data.supNameLast;
                  me.addOffice.supervisoremailId = response.data.supEmail;
                  me.addOffice.supervisorTitle = response.data.supTitle;
                  me.addOffice.userId = response.data.userId;
                  for (var i = 0; me.departmentTypes.length > 0; i++) {
                     if (response.data.departmentTypeId == me.departmentTypes[i].id) {
                        me.addOffice.selectDeptType = me.departmentTypes[i].id;
                        break;
                     }
                  }
                  me.addOffice.departmentId = response.data.departmentId;
                  me.departments = [];
                  officeManagementService.getAllDepartments(me.addOffice.selectDeptType).then(function (res) {
                    if (res && res.data) {
                      for (var i = 0; i < res.data.length; i++) {
                        me.departments.push(res.data[i]);
                      }

                      if(me.departments.length>0)
                      {
                        for(var j=0; j<=me.departments.length; j++)
                        {
                          if(me.departments[j].departmentId == me.addOffice.departmentId)
                          {
                              me.addOffice.selectDeptment = me.departments[j].departmentId;
                              break;
                          }
                        }
                      }

                    }
                });
              }
            });
          }
          else
          {
						me.message = '';
            me.disableFlag=false;
            me.addOffice.officeName=null;
            me.addOffice.officeAbbreviation=null;
            me.addOffice.description=null;
            me.addOffice.firstName=null;
            me.addOffice.lastName=null;
            me.addOffice.emailId=null;
            me.addOffice.title=null;
            me.addOffice.supervisorfirstName=null;
            me.addOffice.supervisorlastName=null;
            me.addOffice.supervisoremailId=null;
            me.addOffice.supervisorTitle=null;
            me.addOffice.selectDeptType="";
            me.addOffice.selectDeptment=null;
            me.addOffice.departmentId=null;
            me.addOffice.userId=null;
            me.headingtitle="Add New Office";
          }
        	me.$refs['my-modal'].show();
			},
      onSaveOffice(headingtitle) {
        const me=this;
        me.message="Processing please wait..";

        var flag=true;
        console.log("me.headingtitle",me.headingtitle);
        if(me.headingtitle=="Add New Office")
            flag=true;
         else
            flag=false;

        if (this.$refs.form.validate())
        {
          debugger;
          const activeSurveyId = authTokenService.getActiveSurveyId();
          me.isLoading = true;
          const currentVolume = authTokenService.getCurrentVolume();
          surveyService.savesubOffice(activeSurveyId, me.addOffice.selectDeptment, me.addOffice.officeName, me.addOffice.officeAbbreviation, me.addOffice.description,
            me.addOffice.firstName, me.addOffice.lastName, me.addOffice.emailId, me.addOffice.title, me.addOffice.supervisorfirstName, me.addOffice.supervisorlastName, me.addOffice.supervisoremailId, me.addOffice.supervisorTitle, me.addOffice.userId, currentVolume, flag)
              .then(function(response)
              {
                  if (response.data == "Successfully saved")
                  {
                    me.isLoading = false;
                    me.message = response.data;
                    me.participatingOffices = [];
                    me.offices = [];
                    setTimeout(() => {
											me.OnLoad();
											if (flag == true) {
											me.message = '';
											me.addOffice.officeName = null;
											me.addOffice.officeAbbreviation = null;
											me.addOffice.description = null;
											me.addOffice.firstName = null;
											me.addOffice.lastName = null;
											me.addOffice.emailId = null;
											me.addOffice.title = null;
											me.addOffice.supervisorfirstName = null;
											me.addOffice.supervisorlastName = null;
											me.addOffice.supervisoremailId = null;
											me.addOffice.supervisorTitle = null;
											me.addOffice.selectDeptType = "";
											me.addOffice.selectDeptment = null;
											me.addOffice.departmentId = null;
											me.addOffice.userId = null;
										 }
										}, 2000);
									} else {
                    me.isLoading = false;
                    me.message = response.data;
                  }
              })
              .catch(function (response) {
                if(me.addOffice.selectDeptType == "")
                  me.message = "Please select Department Type";
                else if(me.addOffice.selectDeptment == null)
                  me.message = "Please select Department name";
                else
                  me.message = "Error occured or please verify the required fields or office name may exists";
                me.isLoading = false;
              });
       }
    },
		onCancel () {
			// Return to landing page. There will be variation on this dependening where user came from.
			router.push({ name: 'landing' });
		},
		hideModal () {
        this.$refs['my-modal'].hide();
      },
    switchuser(usernameVal,participatingOfficesList) {
      debugger;
      this.$data.isLoading = true;
      let me = this;
      var uservalue=null;
      var password=null;
      for(var i=0; i< participatingOfficesList.length; i++)
      {
            if(usernameVal==participatingOfficesList[i].userName)
            {
              uservalue=participatingOfficesList[i].userName;
              password=participatingOfficesList[i].showPassword;
              break;
            }
      }
      authService
        .login(uservalue, password)
        .then(function(response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: "landing" });
        })
        .catch(function(response) {
          console.log("Test handle error in component");
          me.$data.error = true;
          me.$data.isLoading = false;
        });
    },
    OnLoad() {
      const me = this;
      const activeSurveyId = authTokenService.getActiveSurveyId();
      me.participatingOffices = [];
      officeManagementService.getSubOffices(activeSurveyId).then(function (response) {
        if (response && response.data) {
          for (var i = 0; i < response.data.length; i++)
          {
            me.participatingOffices.push(response.data[i]);
          }
        }
      });
      //getAllSubOffices which are Available
      debugger;
      me.offices=[];
      officeManagementService.getAvaiableSubOffices(activeSurveyId).then(function (response) {
        if (response && response.data) {
          console.log(response);
          for(var i=0;i<response.data.length;i++)
          {
            me.offices.push(response.data[i]);
          }
          if(response.data.length==0)
          {
            me.offices=[];
            me.disablemakeOfficeinUseFlag = true;
          }
        }
      });
    },
    onAddSelectedOffices()
    {
        debugger;
        const me = this;
        me.disablemakeOfficeinUseFlag = true;
        me.officeMessage="Processing please wait..";
        me.$data.isLoading = true;
        me.participatingOfficesList=[];
        for(var i=0; i<me.officeSelection.length; i++)
        {
           me.participatingOfficesList.push(me.officeSelection[i].userName);
        }
        const currentVolume = authTokenService.getCurrentVolume();
        me.participatingOfficesList.push(currentVolume);
        surveyService.makeUseOfAvaiableOffice(me.participatingOfficesList).then(function(response) {
             if (response && response.data) {
               me.disablemakeOfficeinUseFlag = false;
                setTimeout(() => {  me.OnLoad(); }, 2000);
                me.$data.isLoading = false;
                me.officeMessage=response.data;
             }
            })
            .catch(function(response) {
              console.log("makeUseOfAvaiableOffice handle error in component");
              me.$data.isLoading = false;
              me.$data.error = true;
              me.officeMessage=response.data;
            });
      me.$data.isLoading = false;
    },
	},
	mounted () {
      const me = this;
			const claims = authTokenService.getClaims();
			if (claims.userName === "Admin")
    	{
        const activeId = authTokenService.getActiveSurveyId();
        claims.surveyId = activeId;
        me.impersonation = true;
        me.isNotUnderAdmin="isDisabled";
        officeManagementService.getOfficeBySurveyId(activeId).then(function (response) {
            if (response && response.data) {
              me.officeDescription = response.data.description;
              me.officeId = response.data.id;
            }
		    });
    	}
      const activeSurveyId = authTokenService.getActiveSurveyId();
      me.participatingOffices=[];
      officeManagementService.getSubOffices(activeSurveyId).then(function (response){
        if (response && response.data) {
          for(var i=0;i<response.data.length;i++)
          {
            me.participatingOffices.push(response.data[i]);
          }
        }
      });

      //getAllSubOffices which are Available
      me.offices=[];
      officeManagementService.getAvaiableSubOffices(activeSurveyId).then(function (response){
        if (response && response.data) {
          console.log(response);
          for(var i=0;i<response.data.length;i++)
          {
            me.offices.push(response.data[i]);
          }
        }
      });
      //Need to check for survey status islocked or not
      surveyService.getLockStatus(activeSurveyId).then(function (response) {
				if (response && response.data != null) {
          console.log("response.data", response.data);
					if (response.data.isLocked == true) {
              me.isSurveyLocked=true;
					}
					else {
            me.isSurveyLocked=false;
					}
				}
			});
	}
};
</script>

<style scoped>
.survey-container {
  width: 100%;
  margin: 0 auto;
}

.buttons {
  width: 80%;
  margin: 20px auto;
  text-align: center;
}

</style>
